export enum AdminRoles {
  WE_ADMIN = 'WE_ADMIN',
  WE_KSD_MAC_KSAdmin = 'WE_KSD_MAC_KSAdmin',
  WE_KSD_MAC_VMAdmin = 'WE_KSD_MAC_VMAdmin',
  WE_KSD_MAC_ALL = 'WE_KSD_MAC_ALL',
  WE_KSD_MAC_SG = 'WE_KSD_MAC_SG',
  WE_KSD_MAC_WAERME = 'WE_KSD_MAC_WAERME',
  WE_KSD_MAC_TANKE = 'WE_KSD_MAC_TANKE',
  WE_KSD_MAC_SUPERSCHNELL = 'WE_KSD_MAC_SUPERSCHNELL',
  WE_VERWALTEN = 'WE_VERWALTEN',
  WE_REGISTRIEREN = 'WE_REGISTRIEREN',
  WE_KSD_MAC_AnyMAC = 'WK.MAC.AnyMAC',
}
